import { Portal } from "@mantine/core";
import css from "./DockCardScrim.module.scss";

// Soft white ramp under the review card so it does not float on raw page
// content.
//
// It MUST be portalled to the body. `.column` carries a translate for its
// centring, and a transformed ancestor becomes the containing block for
// `position: fixed` descendants — inside the column this was being sized and
// positioned against a 40rem box instead of the viewport, which is why it
// never appeared.
//
// It is not a veil: pointer-events stay off, so every click still reaches the
// page underneath.
const DockCardScrim = () => (
  <Portal>
    <div className={css.scrim} aria-hidden="true">
      <div className={css.blur} />
      <div className={css.tint} />
    </div>
  </Portal>
);

export default DockCardScrim;
